export const ContractIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 5.16683V11.8335C14 13.8335 13 15.1668 10.6667 15.1668H5.33333C3 15.1668 2 13.8335 2 11.8335V5.16683C2 3.16683 3 1.8335 5.33333 1.8335H10.6667C13 1.8335 14 3.16683 14 5.16683Z"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66699 3.5V4.83333C9.66699 5.56667 10.267 6.16667 11.0003 6.16667H12.3337"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33301 9.1665H7.99967"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33301 11.8335H10.6663"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
